import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "../../assets/css/pane.module.scss";
import Back from "../../assets/img/Back.svg";
import { postMparticleEvent } from "../../libs/events";
import { goBack, setLogout } from "../../redux/slices/remittanceSlice";

const RemittanceDashboardRightPane = ({ children }) => {
  const dispatch = useDispatch();

  const { isBackBtnEnabled } = useSelector((state) => state.remittance);

  const handleBack1 = () => {
    dispatch(goBack(true));
  };

  const handleLogOut = () => {
    postMparticleEvent({
      eventName: "Remittance_logout",
      eventType: ["EVENT"],
      attributes: {
        screen_name: "remittance",
      },
    });
    dispatch(setLogout(true));
  };

  return (
    <div className={styles.rightPane}>
      <div className={styles.btnConatiner}>
        <div className={styles.backBtnConatiner} onClick={handleBack1}>
          {isBackBtnEnabled ? (
            <>
              <img src={Back} alt="" />
              <span className={styles.backBtnText}>Back</span>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className={styles.logoutbtn} onClick={handleLogOut}>
          Log Out
        </div>
      </div>
      <div className={styles.mainContainer}>{children}</div>
    </div>
  );
};
export default RemittanceDashboardRightPane;
